import React from "react";
import './style.scss'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null, errorInfo: null };

    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        // 
        // this.setState({
        //     error: error?.message
        // })
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        // Catch errors in any components below and re-render with error message
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
        // You can also log error messages to an error reporting service here
    }

    render() {
        if (this.state.errorInfo) {
            // Error path
            return (
                <div className="error-boundary">
                    <div>
                        <div>
                            <div className="logo-container" >
                                <img className="logoSidbar logo-sidebar-opened" src="./images/dartamasLogo.png" />
                            </div>
                            <h2>متاسفانه، خطای پیش‌بینی نشده ای اتفاق افتاده‌است.</h2>
                            <div className="d-flex justify-content-center align-items-center p-3" >
                                <code className="my-2">
                                    {this.error}
                                </code>
                                <code className="my-2">
                                    {this.errorInfo}
                                </code>
                            </div>
                            <div className="d-flex justify-content-center" >
                                <button className="my-5 btn btn-primary" onClick={() => window.location.reload()} >تلاش مجدد</button>
                            </div>
                        </div>


                    </div>

                </div>
            );
        }
        // Normally, just render children
        return this.props.children;
    }
}
export default ErrorBoundary